import { render, staticRenderFns } from "./HonoraryDataTable.vue?vue&type=template&id=5d040224"
import script from "./HonoraryDataTable.vue?vue&type=script&lang=js"
export * from "./HonoraryDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports